import React from 'react'

const HorizontalChartToolTip = ({ active, payload, label }) => {   
    if (active && payload && payload.length) {
        return (
            <div className="custom-horizontal-chart-tooltip">
                <p className="value">{`${payload[0].value.toFixed(2)}`}</p>
            </div>
          );
    }  
    return null;
  };

  export default HorizontalChartToolTip;